import { AtributoEstiloSegmento } from "./atributo-estilo-segmento.model";

export class EstiloSegmento {
    idEstiloSegmento: number;
	atributos: AtributoEstiloSegmento[] = [];
}